const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const headers = (token, json = false) => ({
  ...(json ? { "Content-Type": "application/json" } : {}),
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const getAgents = async (token) => {
  const res = await fetch(`${API}/agents`, { headers: headers(token), credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch agents: ${res.status}`);
  return res.json();
};

export const toggleAgent = async (id, token) => {
  const res = await fetch(`${API}/agents/${id}/toggle`, { method: "POST", headers: headers(token), credentials: "include" });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Agent toggle failed");
  return payload;
};

export const getAgentLogs = async (token) => {
  const res = await fetch(`${API}/agents/logs`, { headers: headers(token), credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch agent logs: ${res.status}`);
  return res.json();
};

export const dispatchAgentEvent = async (eventType, payload, token) => {
  const res = await fetch(`${API}/agents/dispatch`, {
    method: "POST",
    headers: headers(token, true),
    credentials: "include",
    body: JSON.stringify({ event_type: eventType, payload }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Agent dispatch failed");
  return data;
};